export default {
  operationRecord: {
    title: "历史记录",
    totalData: "条数据",
    totalPrefix: "共计",
    onlyKeyStep: "只展示关键步骤",
  },
  historyRecode: {
    loading: "拼命加载中",
    headers: {
      name: "名称",
      updateTime: "更新时间",
      operation: "操作",
    },
    empty: "暂无数据",
    more: "更多",
    messages: {
      deleteConfirm: "此操作将永久删除该文件, 是否继续?",
      deleteConfirmTitle: "删除确认",
      confirmButton: "确定",
      cancelButton: "取消",
      cancelKeyStep: "取消关键步骤!",
      addKeyStep: "已加入关键步骤!",
      editSuccess: "修改成功",
      deleteSuccess: "删除成功",
      cancelDelete: "已取消删除",
    },
  },
};
